import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

  public userDetails: any;
  constructor(private router: Router, private userService: UserService) { }

  ngOnInit() {
    
    this.userService.getUserClaims().subscribe((data: any) => {
      // alert("UserDetailComponent init");
      // alert(data);
      this.userDetails = data;

    },
    (err : HttpErrorResponse)=>{
      this.userDetails = null;
    });
  }


  Logout() {
    localStorage.removeItem('userToken');
    //this.router.navigate(['/login']);
    window.location.href = "/login";
    
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/user/user-detail/user-detail.component.ts